<script>
import options from './StafetDeltagSomFighterStepTwo.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-deltag-som-fighter-step-two kb-optimizely-forms"
  >
    <div>
      <h2 class="kb-stafet-step__title">
        {{ labels.selectYourFighterTshirtTitle }}
      </h2>

      <p class="kb-stafet-step__description">
        {{ labels.selectYourFighterTshirtDescription }}
      </p>
    </div>

    <div class="kb-stafet-step__input-wrapper">


      <FormInputDropdown
        fieldName="tshirtSize"
        :modelValue="tshirtSize"
        v-model="tshirtSize"
        :selectOptions="tshirtSizes"
        :placeholder="labels.selectYourFighterTshirtLabel"
        :label="labels.selectYourFighterTshirtLabel"
        :isRequired="true"
        :isValidationError="showTshirtSizeErrorMessage"
        :errorMessageLabel="labels.selectYourFighterTshirtErrorMessage"
        :onChangeCallback="(e) => setTshirtSize(e.target.value)"
      />
    </div>

    <div>
      <h2 class="kb-stafet-step__title">
        {{ labels.fighterArrangementTitle }}
      </h2>

      <p class="kb-stafet-step__description">
        {{ labels.fighterArrangementDescription }}
      </p>
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="participateInFreeLunch"
        :modelValue="participateInFreeLunch.toString()"
        v-model="participateInFreeLunch"
        :label="labels.fighterArrangementBoolLabel"
        :onChangeCallback="(e) => setParticipateInFreeLunch(e.target.checked)"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep2"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
